import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_et6a66kd2z: FaireBrandEntity = {
  token: "b_et6a66kd2z",
  type: "brand",
  name: "Long Island Candy Factory",
  avatarUrl:
    "https://cdn.faire.com/fastly/224817ab68ff4f24b65dff296cfd5a44f519f0230e9453ea210c606313e41808.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a7099dfc0e3f5444e009766befca84211c91fee09ea019984bd47c86d82ff4b0.png",
  logoUrl:
    "https://cdn.faire.com/fastly/224817ab68ff4f24b65dff296cfd5a44f519f0230e9453ea210c606313e41808.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a7099dfc0e3f5444e009766befca84211c91fee09ea019984bd47c86d82ff4b0.png",
  location: "Hauppauge, NY, USA",
  minimumOrderDollars: 146,
  rating: 4.7,
  reviewCount: 459,
  isInsider: true,
  description:
    "99% OF ORDERS SHIP WITHIN 1 BUSINESS DAY.\n\nIf you need something we dont carry by the case just email us and we can customer order anything you want from every brand we have listed",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:32.794Z",
    importedBy: "entity-db-cli",
  },
};
